import React from "react";
import "./flipCounterOne.scss";

const FlipCounterOne = () => {
  
  return (
    <div>
      <div className="flip-ones flip-ones-one">
        <div className="flip-one" data-flip-one="1" data-flip-one-next="1"></div>
        <div className="flip-one" data-flip-one="1" data-flip-one-next="1"></div>
      </div>
    </div>
  );
};
export default FlipCounterOne;
